import { EMPTY_OBJECT } from '../../../constants/common'
import { BulletItemText } from '../BulletItemText'
import { isEmptyNode, isTextNode } from '../BulletList.utils'

import * as styles from './BulletItem.module.css'

/**
 * @import {BulletItemTextProps} from "../BulletItemText/BulletItemText"
 */

/**
 * @typedef {object} BulletItemProps
 *
 * @property {string} [Element]
 *
 * @property {React.ComponentType<BulletItemTextProps>} [Text]
 *
 * @property {string} [className]
 *
 * @property {BulletItemTextProps} [textProps]
 *
 * @property {React.ReactNode} [value]
 */

/**
 * @param {BulletItemProps} props
 */
function BulletItem({
  Element = 'div',
  Text = BulletItemText,
  className = styles.BulletItem,
  textProps: {
    className: textClassName = styles.text,
    ...textProps
  } = EMPTY_OBJECT,
  value,
  ...elementProps
}) {
  return isEmptyNode(value) ? null : (
    <Element {...elementProps} className={className}>
      <div className={styles.content}>
        {isTextNode(value) ? (
          <Text
            {...textProps}
            className={textClassName}
            value={String(value).trim()}
          />
        ) : (
          value
        )}
      </div>
    </Element>
  )
}

export default BulletItem
